'use client';

import { Locales } from '@packages/types';
import { useRouter } from 'next/router';
export const useLocale = () => {
  const { locale } = useRouter();
  return locale as Locales;
};
